// How far the visitor has passed the homepage Threshold into the why (0 → 1).
// Written by Threshold.js from its scroll progress, read per frame by LightField.
export const crossing = { k: 0 };
